import { useState, useEffect } from 'react';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

import { useFavoriteConsumer } from '@spotahome/ui-library/src/tenant/context/FavoriteContext';

import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';

import { getSimilarsQuery } from '@spotahome/marketplace-common/src/graphql/queries/similars';

const BEST_CHOICE_THRESHOLD = 60;

const decorateHomecards = (favorites, homecards = []) =>
  homecards.map(homecard => ({
    ...homecard,
    isFavorite: favorites.includes(parseInt(homecard.id, 10)),
    hasOffer: !!homecard?.offers?.length,
    isBestChoice: homecard?.score?.points >= BEST_CHOICE_THRESHOLD
  }));

const requestListingsAround = async (listingId, locale, dates) => {
  try {
    const { data } = await getSimilarsQuery(getGqlClient())(
      listingId,
      locale,
      dates
    );
    return data?.similars || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const useListingsAround = (listingId, moveIn, moveOut) => {
  // TO-DO: If we move this request to grapqhql, we can stop requesting the list of favorites
  const { favorites } = useFavoriteConsumer();
  const { current: currentLocale } = useSoyuzLocales();
  const [homecards, setHomecards] = useState([]);

  useEffect(() => {
    const updateHomecards = async () => {
      const similarHomecards = await requestListingsAround(
        listingId,
        currentLocale,
        { moveIn, moveOut }
      );

      setHomecards(decorateHomecards(favorites, similarHomecards));
    };

    updateHomecards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moveIn, moveOut]);

  return homecards;
};

export default {
  useListingsAround
};
